import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionRemoveAllOOSItems = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId?: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMOVE_ALL_OOS_ITEMS,
        context: cartId !== undefined ? JSON.stringify({ cartId }) : undefined,
    });
};

export const clickRemoveAllOOSItems = (
    cartAmount: number,
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId?: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_REMOVE_ALL_OOS_ITEMS,
        value: cartAmount,
        context: cartId !== undefined ? JSON.stringify({ cartId }) : undefined,
    });
};
